import DatePicker, { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr-CA';

registerLocale('fr', fr);

export default DatePicker;
